"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLength = exports.getStopNumberLength = void 0;
var getStopNumberLength = function (stopNumber) {
    if (stopNumber)
        return stopNumber.toString().length.toString();
    return "1";
};
exports.getStopNumberLength = getStopNumberLength;
var getLength = function (length, max) {
    if (max === void 0) { max = 6; }
    if (length > max)
        return max;
    return length;
};
exports.getLength = getLength;
